export const CONSULTANT_INFO_FORM_NAME = 'productionControlDetail-consultantInfo';

export const FIELDS = {
	solverName: 'solverName',
	solverSellerIn: 'solverSellerIn',
	superiorName: 'superiorName',
};

export default () => ({
	[FIELDS.solverName]: {
		deepPath: [FIELDS.solverName],
		validations: [],
	},
	[FIELDS.solverSellerIn]: {
		deepPath: [FIELDS.solverSellerIn],
		validations: [],
	},
	[FIELDS.superiorName]: {
		deepPath: [FIELDS.superiorName],
		validations: [],
	},
});
